import React, { Suspense } from 'react';
import { Link } from 'react-router-dom';
import DealsBoard from '../DealsBoard';

const DealsTab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">Deals pipeline</h2>
        <Link
          to="/help?article=crm-deals-pipeline"
          className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-600 shadow-sm transition hover:bg-gray-50"
        >
          ❓ Deals help
        </Link>
      </div>
      <Suspense
        fallback={
          <div className="flex items-center justify-center rounded-xl bg-white p-10 shadow-sm ring-1 ring-gray-100">
            <div className="text-gray-500">Loading deals pipeline...</div>
          </div>
        }
      >
        <DealsBoard />
      </Suspense>
    </div>
  );
};

export default DealsTab;
